export default [
    {
        key: "forwardhead",
        name: "頭前傾",
        definition: {
            name: "定義",
            list: ["頭前傾とは、人体が自然な立位や座位にあるとき、頭が胴体に対して異常に前方に傾いた位置にあることを指します。長時間座っている学生やオフィスワーカーによく見られます。"]
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1、長期間前かがみで仕事をする。仕事で長時間パソコンに向かっていると、頭が習慣的に前に出る",
                "2、習慣的に頭を下げてスマホを見る。頭を下げてスマホを見る、いわゆる‘スマホ首族’も頭前傾の主な誘因となる。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、めまいと頭痛：頭前傾は頭部の血流に影響を与える可能性があります。血流が悪くなることで頭部の酸素不足が起こり、めまいや頭痛を引き起こします。",
                "2、頸椎病：頭の異常な位置により、首の軟組織や骨に異常が生じ、頸椎病の罹患リスクが高まります。",
                "3、心臓血管疾患と脳血管疾患：頭の異常な位置は頭部の血流に影響を与え、心臓血管と脳血管の健康を損なう可能性があります。",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "頭側傾",
        definition: {
            name: "定義",
            list: ["頭側傾とは、人体が自然な立位や座位にあるとき、頭が過度に片側に傾いた異常な姿勢を指します。主な誘因は左右両側の肩頸部の筋肉の力の不均衡で、多くは慣習的な間違った姿勢によって引き起こされます。"]
        },
        triggerreason: {
            name: "原因",
            list: [
                "1、片側の肩頸部の筋肉を慣用的に使う：座ったり横になったりすると、首は多くの場合片方にだけ傾き、左右両側の肩頸部の筋力の不均衡を引き起こす。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、筋肉や靭帯の慢性的な疲労：長期間の頭側傾は、首の後ろの靭帯や筋肉靭帯の慢性的な疲労を引き起こしやすい。",
                "2、頸椎病：頭の異常な位置により、首の軟組織や骨に異常が生じ、頸椎病の罹患リスクが高まります。",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "肩の高さが違う",
        definition: {
            name: "定義",
            list: ["肩の高さが違うとは、人体が自然にリラックスした状態で、左右の肩の垂直方向の高さが異なる状況を指します。通常、肩の高さが違うと同時に背骨の姿勢にも異常が見られることが多い。"]
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1、片側に過度の負荷：例えば、長期間片側にリュックを背負ったり重いものを持ったりする。",
                "2、長期間の間違った座り方：足を組んで長時間座る、前かがみで仕事をして机に寄りかかるなどの悪い習慣によって引き起こされます。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、腰痛：（肩の高さが違う）は骨盤のずれを引き起こす可能性があり、腰部の左右両側の筋力のバランスが崩れ、腰痛を引き起こします。",
                "2、骨棘：肩の高さが違うと、頸椎に異常な力がかかり、最後には頸椎部位が退化し、骨棘が形成されやすくなります。",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "丸い肩",
        definition: {
            name: "定義",
            list: ["丸い肩は、人体を側面から観察したとき、肩が前方と内側に向かって丸まった状態を指します。多くの場合、猫背とともに現れます。学生やオフィスで働く人々によく見られます。"],
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1、習慣的な姿勢不良：例えば、猫背や不規則な横向き寝など。",
                "2、胸と背中の筋力の不均衡：胸筋は背筋に比べて比較的弱い。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、心臓への負担増加：過度な丸い肩は横隔膜を緊張させ、大動脈と大静脈を圧迫し、心臓の仕事の負担を増加させます。",
                "2、神経が圧迫される：肩と首の周りの筋肉が緊張し、ひどい場合には頸椎神経が圧迫され、頭痛や腕のしびれを引き起こす。",
            ],
        }
    },
    {
        name: "脊柱側弯",
        key: "scoliosis",
        definition: {
            name: "定義",
            list: ["脊柱の位置に異常が生じます。画像検査を通じて、脊柱側弯など脊柱の非直立状態が見つかる可能性があります。異常は先天的と後天的に分けられます。後天的な異常は習慣的な姿勢の誤りと関連しています。"],
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1、片側への過度な負荷：例えば、長期間片側にリュックを背負ったり重いものを持ったりする。",
                "2、長期間の間違った座り方：足を組んで長時間座る、前かがみで仕事をして机に寄りかかるなどの悪い習慣によって引き起こされます。",
                "3、先天的な原因：先天性による脊柱側弯。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、腰椎椎間板ヘルニア。",
                "2、腰痛：骨盤のずれを引き起こし、腰部の左右両側の筋力のバランスを崩し、腰痛を引き起こす可能性があります。",
                "3、足の長さの違い。",
            ],
        }
    },
    {
        name: "骨盤の側方傾斜",
        key: "unevenhip",
        definition: {
            name: "定義",
            list: ["骨盤の側方傾斜とは、左右の腰の高さに大きな差があり、骨盤が傾いた状態を指します。多くの場合、脊柱の位置異常や肩の高さの違いとともに現れます。"],
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1、長期間の間違った座り方：足を組んで長時間座る、前かがみで仕事をして机に寄りかかるなどの悪い習慣によって引き起こされます。",
                "2、先天性の足の長さの違い：先天性の足の長さの違いによる骨盤の側方傾斜。",
                "3、両側の下半身の姿勢の不均衡：例えば、片方の足に扁平足があり、もう片方にはない、または程度が異なる。両側に膝の過伸展があるが、程度が異なる。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、腰椎椎間板ヘルニア。",
                "2、慢性的な痛み：骨盤の側方傾斜は、腰や脚、首や肩の痛みを引き起こす可能性があります。",
                "3、足の長さの違い。",
            ],
        }
    },
    {
        name: "O 脚",
        key: "oleg",
        definition: {
            name: "定義",
            list: ["人体が正常な姿勢で立って、両足を併せた時、内側のくるぶしは密着できますが、膝の内側は密着できず、大きな隙間があることさえあります。足の間に\"O\"の形が現れます。このような脚の形は日常の姿勢の習慣に関連しています。子供に\"O\"型の脚が現れるのは、くる病と関連している可能性もあります。"],
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1、習慣的な悪い姿勢例えば：骨盤後傾、足の内反傾向。",
                "2、筋力の不均衡例えば：股関節外旋筋が過度に緊張している。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、内側半月板損傷：O 型腿により下肢の力線が変化し、膝関節の内側間隙が正常な負荷よりも大きな圧力を受けます。膝関節の内側半月板損傷を引き起こす可能性があります。",
                "2、関節炎：重症（O 型腿）の場合、最終的に膝関節骨性関節炎、関節外側間隙の関節変性に進展する可能性があります。重症の場合は、人工関節置換手術が必要になることがあります。",
            ],
        }
    },
    {
        name: "X 型の脚",
        key: "xleg",
        definition: {
            name: "定義",
            list: "人体が正常な姿勢で立って、両足を併せたとき、内側の膝は密着できますが、両側の足首の内側は密着できず、大きな隙間があることさえあります。足の間には\"X\"の形が現れます。このような脚の形は日常の姿勢の習慣や筋力の不均衡と関係があります。",
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1、習慣的な不良姿勢例えば：骨盤前傾、足の外反傾向。",
                "2、筋力の不均衡例えば：股関節の内旋筋が過度に緊張。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1、外側半月板損傷：X 型腿により下肢の力線が変化し、膝関節の外側間隙が正常な負荷よりも大きな圧力を受けます。膝関節の外側半月板損傷を引き起こす可能性があります。",
                "2、関節炎：重症（X 型腿）の場合、最終的に膝関節骨性関節炎、関節外側間隙の関節変性に進展する可能性があります。重症の場合は、人工関節置換手術が必要になることがあります。",
            ],
        }
    },
    {
        name: "膝過伸展",
        key: "kneehyperextension",
        definition: {
            name: "定義",
            list: ["膝過伸展、別名\"膝反弓\"。人体の側面から見ると、脚が後ろ側に曲がり、膝が内側にくぼみ、ふくらはぎが太ももに比べて過度に前方に伸びていることが見られます。このような体勢はバレリーナや太ももの筋力が弱い人によく見られます。"],
        },
        triggerreason: {
            name: "引き起こす原因",
            list: [
                "1. 間違った力の入れ方：立っているとき、主な体重が足の親指側にかかる。",
                "2. 足底筋膜の緊張：長期にわたってハイヒールを履くことによって引き起こされる可能性があります。",
                "3. 膝関節周辺の筋力が弱い。大腿の前後側の筋力不足。",
            ]
        },
        danger: {
            name: "危険性",
            list: [
                "1. 膝関節の奇形：長期にわたる膝の過伸展は、骨関節の退行性変化の発生率を著しく高め、膝の過度な摩耗を引き起こし、関節の奇形を引き起こす可能性があります。",
                "2. 全身のバランスが損なわれる：股関節、膝関節、足首の三つの関節の間には大きな位置的?機能的なつながりがあります。膝関節の位置の変化は、その下の足首の位置と上の股関節?骨盤の位置に影響を与え、徐々に全身のバランス状態を損ないます。長期的には、さまざまな種類の痛みを引き起こします。",
            ],
        }
    },
]